export default __webpack_public_path__ + "static/img-1-ab35b403f91c41f5849ad57d066617e9.png";